<lucide-angular *ngIf="message && message.length" name="info" class="w-4 h-4 text-blue-400"
  [appTooltip]="message"></lucide-angular>
